import { Analysis, PossibleRootCauseCategory } from '.';

export class LiverBiliaryAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.bileAcids.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4000);
        } else if (this.ba.bileAcids.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4010);
        }

        if (this.ba.bilirubin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4020);
        } else if (this.ba.bilirubin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4030);
        }

        if (this.ba.bilirubinDirect.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4040);
        } else if (this.ba.bilirubinDirect.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4050);
        }

        if (this.ba.bilirubinIndirect.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4060);
        } else if (this.ba.bilirubinIndirect.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4070);
        }

        if (this.ba.alp.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4080);
        } else if (this.ba.alp.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4090);
        }

        if (this.ba.ast.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4100);
        } else if (this.ba.ast.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4110);
        }

        if (this.ba.alt.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4120);
        } else if (this.ba.alt.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4130);
        }

        // AST/ALT ratio (calculated). ▲ = AST-dominant (alcohol, muscle, non-liver
        // AST, falling ALT with age or muscle loss); ▼ = ALT-dominant (the
        // liver-fat / metabolic pattern). Ids 4132/4134 predate this code: they
        // were authored as Causes rows before the marker existed.
        if (this.ba.astAltRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4132);
        } else if (this.ba.astAltRatio.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4134);
        }

        if (this.ba.ggt.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4140);
        } else if (this.ba.ggt.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4150);
        }

        if (this.ba.lactateDehydrogenase.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4160);
        } else if (this.ba.lactateDehydrogenase.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4170);
        }

        // Hepatic Steatosis Index: one ▲ row covering both the indeterminate
        // band (30-36, outside optimal) and the rule-in band (>36, outside lab).
        // A low HSI is not a finding, so there is no ▼ category.
        if (this.ba.hsi.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4180);
        }

        // FIB-4 index: one ▲ row covering the indeterminate band (1.3-2.67, or
        // 2.0-2.67 from age 65) and the rule-in band (>2.67). No ▼ category.
        if (this.ba.fib4.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_4190);
        }
    }
}